import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SqueezePage from "@/pages/SqueezePage";
import Experience from "@/pages/Experience";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<SqueezePage />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster position="top-center" theme="light" richColors />
    </BrowserRouter>
  );
}

export default App;
